export const degreeStreamPayload = data => {
  const returnData = data?.flatMap(degree => {
    if (degree?.streams?.length > 0) {
      return degree.streams.map(stream => ({
        degreeId: degree.degreeId,
        streamId: stream,
      }))
    }
    return {
      domainId: degree.degreeId,
    }
  })
  return returnData
}

export const labelChangeFunction = label => {
  switch (label) {
    case 'PLACEMENT':
      return 'Placement'
    case 'INTERNSHIP':
      return 'Internships'
    case 'APPRENTICESHIP':
      return 'Apprenticeship'
    case 'GIGS':
      return 'Gigs'
  }
}

export const jobCategoryFilterData = data => {
  if (data?.length > 0) {
    let jobCat = data.map(item => ({
      label: labelChangeFunction(item),
      value: item,
    }))
    return jobCat
  }
}

export const jobCategoryData = [
  'PLACEMENT',
  'INTERNSHIP',
  'APPRENTICESHIP',
  'GIGS',
]

export const getPlacedStatus = status =>
  status === 'INTENT_TO_OFFER' ? 'Intent to Offer' : 'Offer Acceptance'

export const formatNumber = num => {
  if (!num) return ''

  const cleaned = num.toString().replace(/\D/g, '')

  const lastThreeDigits = cleaned.slice(-3)
  const otherDigits = cleaned.slice(0, -3)

  let formattedNumber = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',')

  return formattedNumber + (formattedNumber ? ',' : '') + lastThreeDigits
}

export const checkFormatNumber = value => {
  const parsed = value?.replace(/\$\s?|(,*)/g, '')
  return !isNaN(parsed) && parsed.trim() !== '' ? parsed : undefined
}

export const convertToNumber = formattedValue => {
  if (formattedValue === null || formattedValue === undefined) return 0

  const valueAsString = String(formattedValue)

  const cleanedValue = valueAsString.replace(/,/g, '')
  const numericValue = parseFloat(cleanedValue)

  return isNaN(numericValue) ? 0 : numericValue
}

export const handleKeyDown = e => {
  if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
    e.preventDefault()
  }
}

export function formatCTC(value, addSuffix = false) {
  if (addSuffix) {
    return formatNumber(value)
  }
  if (value >= 1000 && value < 100000) {
    const kValue = Math.floor(value / 1000)
    return kValue + 'K'
  } else if (value >= 100000 && value <= 99999999) {
    const lpaValue = Math.floor(value / 100000)
    return lpaValue + ' LPA'
  }
  return value
}

export const allMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const formatWithHyphens = date => {
  const d = new Date(date)
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  return `${day}/${month}/${year}`
}

export const initialRoleApplyPermit = {
  roleCount: '',
  isEnabled: false,
}
export const initialAbsentCount = {
  missedEvaluationCount: '',
  isEnabled: false,
}

export const initialMaxRolesAllowed = {
  roleCount: '',
  isEnabled: false,
}

export const initialCTCRule = {
  compensation: '',
  isEnabled: false,
  closestCtcRate: '',
  allowClosestCTC: false,
}

export const initialDurationRange = {
  isEnabled: false,
  duration: '',
  tenureRange: [
    {
      isEnabled: false,
      startMonth: null,
      endMonth: null,
    },
  ],
}
